export default function getOS() {
    try {
        var userAgent = window.navigator.userAgent.toLowerCase();
        // iOS devices
        if (/iphone|ipad|ipod/.test(userAgent)) {
            return 'iOS';
        }
        // Android devices
        if (/android/.test(userAgent)) {
            return 'Android';
        }
        // Windows
        if (/windows|win32|win64/.test(userAgent)) {
            return 'Windows';
        }
        // macOS
        if (/macintosh|mac os x/.test(userAgent)) {
            return 'Mac OS';
        }
        // Linux
        if (/linux/.test(userAgent)) {
            return 'Linux';
        }
        // Fallback to platform if available
        if (window.navigator.platform) {
            var platform = window.navigator.platform.toLowerCase();
            if (platform.indexOf('mac') !== -1)
                return 'Mac OS';
            if (platform.indexOf('win') !== -1)
                return 'Windows';
            if (platform.indexOf('linux') !== -1)
                return 'Linux';
        }
        return 'Unknown';
    }
    catch (error) {
        // 如果出现任何错误，返回 Unknown
        return 'Unknown';
    }
}
